














































import Component, { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
import { SensorShowModel } from '@/context/sensor/model/SensorShowModel';
import { sensorApi } from '@/context/sensor/api/SensorApi';
// import { notNullOrUndefined } from "@/utility/functions";
// import DataLoggerShowContainer from "@/context/data_logger/containers/DataLoggerShowContainer.vue";
import { dataLoggerRouter } from '@/context/data_logger/router/DataLoggerRouter';

@Component({
  components: {
    DetailRow
    // DataLoggerShowContainer
  }
})
export default class SensorShowContainer extends mixins(ShowContainer) {
  model!: SensorShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await sensorApi.show(id);
    this.model = response?.data?.view;
    console.log(this.model);
  }
  // get dataLoggerFetchable(): boolean {
  //   const result: boolean = notNullOrUndefined(this.model.dataLoggerId);
  //   return result;
  // }

  get dataLoggerRoute(): Record<string, unknown> | null {
    return this?.model?.dataLoggerId ? dataLoggerRouter.show(this.model.dataLoggerId) : null;
  }

  get dataLoggerLabel(): string {
    return this.model.dataLoggerId ? "Przejdź do detali" : "";
  }
}
